export const REQUEST = 'Admin/SurveyResponses/REQUEST';
export const SUCCESS = 'Admin/SurveyResponses/SUCCESS';
export const ERROR = 'Admin/SurveyResponses/ERROR';

export const SET = 'Admin/SurveyResponses/SET';
export const UPDATED = 'Admin/SurveyResponses/UPDATED';
